import React from "react";

import { Select, MenuItem } from "@material-ui/core";
function GraphSelect({ graph, onSelect, defaultValue }) {
    return (
        <>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={defaultValue}
                onChange={onSelect}

            >
                {graph && graph.map((item, index) => (

                    <MenuItem key={index} value={item.name}>
                        {item.name}
                    </MenuItem>
                ))}
            </Select>
        </>

    );
}

export default GraphSelect;
